import { SEO, Button } from '@martech/ig-summit-ui'
import { FC } from 'react'
import Speaker from 'components/Speaker'
import { allSpeakers } from 'content/speakers'
import { ISpeaker } from 'components/Speaker'
import SpeakerInfo from 'components/SpeakerInfo'
import type { GetStaticPropsContext } from 'next'

const SpeakerPage: FC<ISpeaker> = (speakerInfo) => {
  return (
    <>
      <SEO
        title="Instagram Summit 2022 | ManyChat | Speakers"
        keywords="speakers"
        description="speakers"
      />
      <section className="set-color m_b-xl" data-back="#6a34bf" data-front="#fff">
        <SpeakerInfo {...speakerInfo} />

        <div className="t-flex jcc m_x-xs m_t-m m_b-xxl">
          <Button href="https://events.hubilo.com/igsummit-2022" target="_blank">
            Go to Summit
          </Button>
        </div>
        <hr className="m_x-xs" />
      </section>
      <section className="set-color m_b-xxl" data-back="#ffdb28" data-front="#020202">
        <h2 className="p_x-xs text-center">More our speakers</h2>
        <div className={`grid grid_2 t-grid_3 d-grid_4 gap-y m_t-xl`}>
          {allSpeakers.map((speaker) => (
            <Speaker
              speaker={speaker}
              isActive={speaker.slug === speakerInfo.slug}
              key={speaker.slug}
            />
          ))}
        </div>
        <div className="t-flex jcc m_x-xs m_t-xxl">
          <Button href="https://events.hubilo.com/igsummit-2022" target="_blank">
            Go to Summit
          </Button>
        </div>
      </section>
    </>
  )
}

export default SpeakerPage

export async function getStaticPaths() {
  return {
    paths: allSpeakers.map((speaker) => ({ params: { slug: speaker.slug } })),
    fallback: false,
  }
}

export async function getStaticProps({ params }: GetStaticPropsContext) {
  let speakerInfo = allSpeakers.find((speaker) => speaker.slug === params?.slug)

  return { props: speakerInfo }
}
